var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.useCustomer)?_c('CouponVipPopupCustomer',{attrs:{"couponList":_vm.couponList},on:{"closeCouponPopup":_vm.closeCouponPopup}}):_c('CouponVipPopupCommon',{attrs:{"couponList":_vm.couponList},on:{"closeCouponPopup":_vm.closeCouponPopup}})}
var staticRenderFns = []

export { render, staticRenderFns }